import React from 'react'

import { useMfaSetup } from 'hooks/useMfaSetup'

import LoadingView from '../LoadingView'
import MfaQrCode from './MfaQrCode'
import MfaReset from './MfaReset'

const MFASetup = () => {
  const { error, data, isLoading } = useMfaSetup()

  if (isLoading) return <LoadingView loading={isLoading} />

  const mfaAlreadyConfigured = (error as any)?.status === 429

  if (mfaAlreadyConfigured) return <MfaReset />

  if (!data) return null

  return <MfaQrCode mfaKey={data.key} qrCode={data.qrCode} />
}

export default MFASetup
